<template lang="pug">

    .diagram(:data-scroll='content.diagram.scroll ? "scroll" : "no-scroll"')

        .diagram__wrap
            .diagram__title(v-html='content.title')
            .diagram__ills(ref='ills')
                app-image.diagram__img(:lazy-src="src", :lazy-srcset="srcset", :alt="content.alt")

            .diagram__text-box(v-if='content.diagram.labels')
                .diagram__text(v-for='label in content.diagram.labels', v-html='label', :data-symbol='content.diagram.symbol')

            .diagram__share(v-if="share")
                share(:url="share.shareUrl", :title="share.title", :description="share.description")

</template>

<script>
import Share from '@/components/Share.vue';
import AppImage from '@/components/AppImage.vue';
import {mapGetters} from 'vuex';

export default {
    name: 'diagram',

    props: {
        content: {
            default: () => {
                return {};
            },
            type: Object
        },

        active: {
            default: false,
            type: Boolean
        },

        base: {
            type: String,
            default: ''
        },

        isLiteMode: {
            default: false,
            type: Boolean
        }
    },

    computed: {
        ...mapGetters('core', ['shareMap']),

        src() {
            return this.base + (this.isLiteMode ? this.content.diagram.srcCompact : this.content.diagram.src || '');
        },

        diagram() {
            if (!this.content) return '';
            return this.content.diagram || {};
        },

        srcset() {
            if (!this.srcCompact) return null;
            return `${this.src} 1400w, ${this.base}${this.srcCompact} 800w`;
        },

        share() {
            return this.diagram.shareIndex ? this.shareMap[this.diagram.shareIndex] || null : null;
        }
    },

    components: {
        AppImage,
        Share
    }
};
</script>

<style lang="scss">
//
@import '../assets/css/vars';
//
.diagram {
    position: relative;
    background-color: var(--color-outline-bg);
    border: 1px solid var(--color-accent);
    width: calc(75% + var(--scr-padding-side) * 4);
    padding: calc(var(--scr-padding-side) * 2);
    margin-left: auto;
    margin-right: auto;
    margin-bottom: var(--width-column-grid);

    @media (--viewport-mobile), (--viewport-tablet-pt) {
        width: 100%;
        padding: calc(var(--scr-padding-side) * 2) var(--scr-padding-side);
        margin-bottom: 2rem;
        border: none;
    }

    &__share {
        color: var(--color-header);
        display: flex;
        justify-content: center;
        padding-top: 1em;

        .share__item {
            transform: translateY(30%);
        }
    }

    &__wrap {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    &__title {
        display: block;
        color: var(--color-accent);
        font-family: var(--font-accent);
        padding: 0.5em;
        background-color: rgba(#01fff0, 0.15);
        margin: 0 auto 5em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-bottom: 2em;
        }
    }

    &__ills {
        margin-bottom: 2em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-bottom: 0.5em;
        }
    }

    &[data-scroll='scroll'] {
        @media (--viewport-mobile), (--viewport-tablet-pt) {
            padding-left: 0;
            padding-right: 0;

            .diagram__ills {
                overflow-x: auto;

                .diagram__img {
                    padding: 0 var(--width-column-grid);
                    min-width: 1100px;
                }
            }
        }
    }

    &__text-box {
        display: flex;
        color: var(--color-accent-strong);
        padding: 0 var(--width-column-grid);
        margin-top: 2em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            flex-direction: column;
            margin-top: 1.5em;
        }
    }

    &__text {
        flex-grow: 1;
        display: flex;
        font-size: 0.8em;

        @media (--viewport-mobile), (--viewport-tablet-pt) {
            margin-bottom: 2em;
        }

        &:nth-child(2n) {
            color: var(--color-accent-diagram);
        }

        &[data-symbol='rect'] {
            &:before {
                content: '';
                position: relative;
                display: block;
                top: 0.5em;
                width: 7em;
                height: 0.7em;
                background-color: currentColor;
                box-shadow: 0 0 5px 1px currentColor;
                margin-right: 2em;
            }
        }
    }

    &__img {
        width: 100% !important;
    }
}
</style>
